import { isFreeTrialFirstSegment, isIneligibleFreeTrialBin } from '../checkout/ineligibleFreeTrialBin'

export const GIFTING_PENDING_REFUSAL_REASON = 'Gift payment pending'
export const PREPAID_CARD_REFUSAL_REASON = 'Prepaid Card'

export function isPrepaidIneligibleForSelectedPlan ({
  fundingSourcePrepaid,
  segments,
  enabled,
} = {}) {
  return enabled === true
    && fundingSourcePrepaid === true
    && isFreeTrialFirstSegment(segments)
}

export function isGooglePayIneligibleBinForSelectedPlan ({
  isGooglePay,
  cardBin,
  binList,
  segments,
  enabled,
} = {}) {
  return enabled === true
    && isGooglePay === true
    && isFreeTrialFirstSegment(segments)
    && isIneligibleFreeTrialBin(cardBin, binList)
}

export function getPaymentTokenRefusalReason ({
  giftPaymentPending,
  fundingSourcePrepaid,
  refusalReason,
} = {}) {
  if (giftPaymentPending === true) {
    return GIFTING_PENDING_REFUSAL_REASON
  }
  if (fundingSourcePrepaid === true) {
    return PREPAID_CARD_REFUSAL_REASON
  }
  return refusalReason
}

export function shouldRecordPaymentTokenAsError ({
  fundingSourcePrepaid,
  ineligibleBinAbort,
  hasTruePaymentError,
} = {}) {
  if (hasTruePaymentError === true) {
    return true
  }
  if (fundingSourcePrepaid === true || ineligibleBinAbort === true) {
    return false
  }
  return true
}
